import { render, staticRenderFns } from "./StatisticsGeneralMain.vue?vue&type=template&id=62a5dfc5"
import script from "./StatisticsGeneralMain.vue?vue&type=script&lang=js"
export * from "./StatisticsGeneralMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports